import _ from 'lodash';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromOption from './option.reducer';

export const selectOptionState = createFeatureSelector<fromOption.State>(
  fromOption.optionFeatureKey
);

export const selectOptionList = createSelector(
  selectOptionState,
  (state: fromOption.State) => {
    const entities = _.map(state.entities, entity => entity);
    const sortedEntities = _.sortBy(entities, ['status']); // active at the start

    return _.map(sortedEntities, (data, index) => {
      return { data, index };
    })
  }
);

export const selectActiveOptionList = createSelector(
  selectOptionState,
  (state: fromOption.State) => {
    const entities = _.map(state.entities, entity => entity);
    const avalibleEntities = _.filter(entities, entity => entity.status === 0)
    return _.map(avalibleEntities, (data, index) => {
      return { data, index };
    })
  }
);

export const selectDeletedOptionList = createSelector(
  selectOptionState,
  (state: fromOption.State) => {
    const entities = _.map(state.entities, entity => entity);
    const deletedEntities = _.filter(entities, entity => entity.status === 1)
    return _.map(deletedEntities, (data, index) => {
      return { data, index };
    })
  }
);

export const selectFilteredOptionList = createSelector(
  selectOptionState,
  (state: fromOption.State) => {
    const entities = _.map(state.entities, entity => entity);
    const list = _.map(entities, (data, index) => {
      return { data, index }
    });
    return _.filter(list, ({ data }) => {
        const name = _.chain(data)
            .get('name', '')
            .lowerCase()
            .value();
        const desc = _.chain(data)
            .get('desc', '')
            .lowerCase()
            .value();
        const value = _.chain(state.search)
            .lowerCase()
            .value();
        return _.includes(name, value) || _.includes(desc, value);
    });
  }
);

export const selectSearch = createSelector(
  selectOptionState,
  (state: fromOption.State) => {
    return state.search;
  }
);
